"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.groupInvoicesByMonth = exports.groupInvoicesInMonthByWeek = void 0;
const luxon_1 = require("luxon");
const datetime_1 = require("./datetime");
const stats_1 = require("./stats");
const groupInvoicesInMonthByWeek = (start, invoices) => datetime_1.mondaysInInterval(luxon_1.Interval.fromDateTimes(start, start.endOf('month').endOf('week')))
    .map((monday) => (Object.assign({ monday }, stats_1.flattenInvoicesByWeek(monday, invoices))));
exports.groupInvoicesInMonthByWeek = groupInvoicesInMonthByWeek;
const groupInvoicesByMonth = (invoices) => invoices.reduce((months, invoice) => {
    const lastMonth = months.slice(-1)[0];
    return (lastMonth !== undefined
        && lastMonth.start.hasSame(invoice.start.startOf('week'), 'month'))
        ? [
            ...months.slice(0, -1),
            {
                start: lastMonth.start,
                invoices: [
                    ...lastMonth.invoices,
                    invoice,
                ],
            },
        ]
        : [
            ...months,
            {
                start: invoice.start.startOf('month'),
                invoices: [invoice],
            },
        ];
}, []);
exports.groupInvoicesByMonth = groupInvoicesByMonth;
//# sourceMappingURL=invoice.js.map